import { render } from "./AddToBag.vue?vue&type=template&id=7156e816&scoped=true"
import script from "./AddToBag.vue?vue&type=script&lang=js"
export * from "./AddToBag.vue?vue&type=script&lang=js"

import "./AddToBag.vue?vue&type=style&index=0&id=7156e816&lang=scss&scoped=true"
import "./AddToBag.vue?vue&type=style&index=1&id=7156e816&lang=scss"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7156e816"]])

export default __exports__